export default __webpack_public_path__ + "static/media/SuccessfullPurchase.573eed3c.png";